export const FETCH_DCM_PLACEMENTS = "FETCH_DCM_PLACEMENTS";
export const FETCH_DCM_CAMPAIGNS = "FETCH_DCM_CAMPAIGNS";
export const FETCH_ADS = "FETCH_ADS";
export const FETCH_ASSIGNED_CREATIVES = "FETCH_ASSIGNED_CREATIVES";
export const FETCH_DCM_LANDING_PAGES = "FETCH_DCM_LANDING_PAGES";
export const FETCH_DYNAMIC_TARGETING_KEYS = "FETCH_DYNAMIC_TARGETING_KEYS";

export const SET_ADVERTISER_ID = "SET_ADVERTISER_ID";
export const SELECT_CAMPAIGN_ID = "SELECT_CAMPAIGN_ID";

export const ADD_CUSTOM_LANDING_PAGE = "ADD_CUSTOM_LANDING_PAGE";
export const CLEAR_LANDING_PAGES = "CLEAR_LANDING_PAGES";
